export class keyvaluepair {
    key: string;
    value: string; 
    SessionCode: string;
    ClinicCode: string;   
}

export class Bookingkeyvaluepair {
    key: string;
    value: string;
    drCode: string;
    slotMessage: string;
    SessionCode: string;
    ClinicCode: string;
}

export class ServicePaykeyvaluepair {
    key: string;
    value: number;    
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/parameters/keyvaluepair.ts